import { render, staticRenderFns } from "./botStatus.vue?vue&type=template&id=53755a7c&"
import script from "./botStatus.vue?vue&type=script&lang=js&"
export * from "./botStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports